import React, { useEffect, useMemo, useState } from "react";
import {
  CAlert,
  CButton,
  CInput,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from "@coreui/react";

import { Role } from "utils";
import { Loading, ButtonsContainer } from "components";
import { useUpdateCarehomeSubscriptionsMutation } from "pages/Carehomes/Carehomes.query";

const EditSubscriptionsModal = ({ subscription, show, onClose, userId }) => {
  const [saveSuccess, setSaveSuccess] = useState(false);

  const [thriversValue, setThriversValue] = useState(
    Number(subscription?.thrivers)
  );
  useEffect(() => {
    setThriversValue(Number(subscription?.thrivers));
  }, [subscription]);

  const onCloseEditModal = () => {
    setThriversValue(Number(subscription?.thrivers));
    setSaveSuccess(false);
    onClose();
  };

  // Edit subscription
  const {
    mutateAsync: updateSubscriptions,
    isLoading: loading,
    reset,
  } = useUpdateCarehomeSubscriptionsMutation();

  const handleEditSubscription = () => {
    updateSubscriptions(
      {
        userId,
        subscriptionId: subscription.identifier,
        thrivers: thriversValue,
      },
      { onSuccess: () => setSaveSuccess(true) }
    );
  };

  const hasChanges = useMemo(
    () => subscription?.thrivers !== thriversValue,
    [thriversValue, subscription?.thrivers]
  );

  return Role.adminAccess() ? (
    <span>
      <CModal size="sm" show={show} onClose={onCloseEditModal}>
        <CModalHeader closeButton>
          <CModalTitle>Edit subscription</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <div className="d-flex align-items-center gap-15">
            Number Thriver  Licences *
            <CInput
              type="number"
              name="thrivers"
              required
              placeholder="Subscriptions"
              onChange={(e) => {
                reset();
                setThriversValue(Number(e.target.value));
              }}
              value={thriversValue || 0}
              min={1}
              style={{ width: "140px" }}
            />
          </div>
          {saveSuccess && (
            <CAlert color="success" className="mt-3">
              Subscription edited successfully.
            </CAlert>
          )}
          <ButtonsContainer>
            <Loading show={loading} />
            <CButton
              disabled={loading}
              color="danger"
              onClick={onCloseEditModal}
            >
              Close
            </CButton>

            <CButton
              disabled={loading || !hasChanges}
              color="primary"
              onClick={handleEditSubscription}
            >
              Save
            </CButton>
          </ButtonsContainer>
        </CModalBody>
      </CModal>
    </span>
  ) : null;
};

export default EditSubscriptionsModal;
